import { ShopOutlined } from '@ant-design/icons';

import StorePage from '../pages/StorePage';

import { SiteMap } from './index';

export const storeRoutes: SiteMap = {
  store: {
    title: '매장 관리',
    page: StorePage,
    icon: <ShopOutlined />,
    key: '/store',
  },
};
